import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ProjectNameLinkProps {
  projectName: string;
  children: React.ReactNode;
}

export function ProjectNameLink({ projectName, children }: ProjectNameLinkProps) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/content/project?search=${encodeURIComponent(projectName)}`);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick(e as unknown as React.MouseEvent)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: 'pointer',
        color: 'inherit',
        textDecoration: isHovered ? 'underline' : 'none',
      }}
    >
      {children}
    </span>
  );
}
